<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Remove provider from region</cll-dialog-title>
        <cll-dialog-subtitle>{{ data.provider.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <cll-panel-tonal colour="warning">
                <cll-icon cllPanelIcon>warning</cll-icon>
                <div class="panel-text-group">
                    <span class="panel-text-header">Remove from region</span>
                    <span class="panel-text-sub-header">This provider will no longer be associated with this region.</span>
                </div>
            </cll-panel-tonal>
            <span>Are you sure you want to proceed?</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (removeRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="removeRequest.loading()"
                (click)="remove()">
            Remove
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
